<template>
  <div class="layout-with-centered-max-width-child">
    <div>
      <div class="each-row text">
        <span>{{ theQuestion }}</span>
      </div>
      <div class="each-row">
        <div class="dropdown-container">
          <div class="dropdown-container-columns"></div>
          <div class="dropdown-container-columns text">
            <span>Minimum</span>
          </div>
          <div class="dropdown-container-columns"></div>
          <div class="dropdown-container-columns text">
            <span>Maximum</span>
          </div>
          <div class="dropdown-container-columns"></div>
        </div>
        <div class="dropdown-container">
          <div class="dropdown-container-columns"></div>
          <div class="dropdown-container-columns" v-on:click="focusOnThisPlease">
            <Dropdown :selection=lowerBound>
              <div class="option" v-for="age in agesMinimum" @click="setLowerBound(age)">
                <span class="options-text">{{age}}</span>
              </div>
            </Dropdown>
          </div>
          <div class="dropdown-container-columns text">
            <span>-</span>
          </div>
          <div class="dropdown-container-columns" v-on:click="focusOnThisPlease">
            <Dropdown :selection=upperBound>
              <div class="option" v-for="age in agesMaximum" @click="setUpperBound(age)">
                <span class="options-text">{{age}}</span>
              </div>
            </Dropdown>
          </div>
          <div class="dropdown-container-columns"></div>
        </div>
      </div>
      <div class="each-row">
        <StudyNavigation></StudyNavigation>
      </div>
    </div>
  </div>
</template>

<script>
  import StudyNavigation from "../views/StudyNavigation"
  import Dropdown from "../general/Dropdown"
  import {
    GET_NEXT_STUDY_STEP_ROUTE,
    LOAD_SURVEY_QUALIFICATIONS, LOADING_COMPLETED_SUCCESS, R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_LANGUAGE,
    SET_SURVEY_SELECTED_QUALIFICATIONS
  } from "../../services/constants"
  import {mapGetters} from "vuex"

    export default {
      name: "SurveyQualificationOpenEnd",
      components: {Dropdown, StudyNavigation},

      props: {
        qualification: {
          type: Object,
          default(){
            return {}
          },
        }
      },


      created() {
        this.setSelections()
      },

      data(){
        return{
          lowerBound: 0,
          upperBound: 0,
          touched: false
        }
      },

      computed: {
        ...mapGetters([
          GET_NEXT_STUDY_STEP_ROUTE,
        ]),
        agesMinimum(){
          return [...Array(this.biggestPossibleOption()).keys()].slice(this.smallestPossibleOption());
        },
        agesMaximum(){
          return [...Array(this.biggestPossibleOption()).keys()].slice(this.lowerBound);
        },
        theQuestion(){
          return `If you would like to limit respondents based on ${this.qualification.name},
          select desired qualifications below.  Or skip to get a random sampling`
        },
      },

      watch: {
        lowerBound(val) {
          this.upperBound = val > this.upperBound ? val : this.upperBound
        },
        '$route'() {
          this.precodes = this.createPrecodes()
          this.setSelections()
        }
      },

      methods:{
        setLowerBound(number){
          this.lowerBound = number
        },
        setUpperBound(number){
          this.upperBound = number
        },
        focusOnThisPlease(){
          if(!this.touched){
            this.touched = true
            this.lowerBound = this.smallestPossibleOption()
            this.upperBound = this.smallestPossibleOption()
          }
        },
        handleSubmit(){
          let id = this.getQualificationID()
          let arr = this.$store.state.dataModule.selectedQualifications.qualifications
          arr = this.removeObjectWithId(arr, id)
          if (this.upperBound > 0){
            arr.push({'id': id, 'precodes': [...Array(this.biggestPossibleOption()).keys()].slice(this.lowerBound, this.upperBound+1)})
            console.log(arr)
            this.$store.commit(SET_SURVEY_SELECTED_QUALIFICATIONS, {"qualifications": arr})
          }
          this.$router.push(this[GET_NEXT_STUDY_STEP_ROUTE])
        },
        getQualificationID(){
          return this.qualification.id
        },
        smallestPossibleOption(){
          return this.qualification.name === 'Age' ? 16: 0
        },
        biggestPossibleOption(){
          return 100
        },
        removeObjectWithId(arr, id){
          return arr.filter(qual => qual.id !== id);
        },
        setSelections(){
          let arr = this.$store.state.dataModule.selectedQualifications.qualifications
          let selections = arr.filter(qual => qual.id === this.getQualificationID())
          if (selections[0] && 'precodes' in selections[0]){
            this.lowerBound = Math.min(...selections[0].precodes)
            this.upperBound = Math.max(...selections[0].precodes)
          }
        },
      },
    }
</script>

<style scoped>

  .text{
    text-align: center;
  }

  .dropdown-container{
    padding: 0 10%;
  }

  .dropdown-container-columns{
    width: 20%;
    display: inline-block;
  }

  .dropdown-container-columns{
    width: 20%;
    display: inline-block;
  }

  .each-row{
    padding: 5% 0;
  }

  span {
    font-size: 1.17em;
  }

  .option {
    padding: 5px 20px;
    border: 1px solid rgba(0, 0, 0, 0.25);
    cursor: pointer;
  }

  .options-text{
    font-size: 16px;
  }

</style>
